import { render } from "./InvoiceTemplatePreview.vue?vue&type=template&id=cb66d8ec&ts=true"
import script from "./InvoiceTemplatePreview.vue?vue&type=script&lang=ts"
export * from "./InvoiceTemplatePreview.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__